import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const GuestRoute = ({
  isAuthenticated,
  location,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props =>
        !isAuthenticated ? (
          <Component location={location} {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

const mapStateToProps = state => {
  return {
    isAuthenticated: !!state.practitioner.token
  };
};

export default connect(mapStateToProps)(GuestRoute);
